
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Loading from '@/components/Loading.vue';

	@Component({
		components: { Loading, Modal }
	})
	export default class Modal extends Vue {
		private classes: any;
		@Prop() private msg!: string;

		private restart() {
			this.$emit('restart');
		}
	}
